// extracted by mini-css-extract-plugin
export default {"movie-search":"MovieSearch_movie-search__pF-em","clear":"MovieSearch_clear__QCb-o"};